import { api } from "../.."

// função para pesquisar funcionários
const ManagersEmployeesService = async (name: string, costCenter: number, page: number) => {

    const response = await api.get('managers/employees', {
        params: {
            name, costCenter, page
        }
    });

    return response;

}
// função para pesquisar funcionários

// função para pesquisar informações de um funcionário
const ManagersEmployeesShowService = async (id: number) => {

    const response = (await api.get(`/managers/employees/${id}`));

    return response;

}
// função para pesquisar informações de um funcionário

// função para editar um usuário
const ManagersEmployeesUpdateService = async (id: number, cpf: string, bank: string, agency: string, account: string) => {

    const response = await api.put(`/managers/employees/${id}`, {
        cpf, bank, agency, account
    });

    return response;

}
// função para editar um usuário

// função para pesquisar dados de um funcionário
const ManagersEmployeesUserService = async (id: number) => {

    const response = await api.get(`/managers/employees/user/${id}`);

    return response;

}
// função para pesquisar dados de um funcionário

// função para alterar a senha de um usuário
const ManagersEmployeesPasswordService = async (id: number, password: string) => {

    const response = await api.put(`/managers/employees/password/${id}`, {
        password
    });

    return response;

}
// função para alterar a senha de um usuário

const ManagersEmployeesCostCenterService = async (id: number, name: string, page: number) => {

    const response = await api.get(`/managers/employees/cost_center/${id}`, {
        params: {
            name, page
        }
    });

    return response;

}

export {
    ManagersEmployeesService,
    ManagersEmployeesShowService,
    ManagersEmployeesUpdateService,
    ManagersEmployeesUserService,
    ManagersEmployeesPasswordService,
    ManagersEmployeesCostCenterService
}